/** Hover tips for left-panel / mobile school list section headers. */
export const SCHOOL_LIST_TIPS = {
  inCatchment:
    "Home is inside this school’s published priority or designated catchment for the year on the map.",
  openToAll:
    "Schools that take applicants from anywhere, or that have both a priority area and open places. A number in brackets is the published open-place quota when known.",
  possible:
    "Within about 8 miles, with no confirmed catchment for this home, or only distance-based offer history.",
  outside:
    "The school has a published catchment and this home is outside it.",
};
